import React, { useState } from "react";

const REQUEST_TYPES = {
  full_name: "Thay đổi họ và tên",
  phone_number: "Thay đổi số điện thoại",
  email: "Thay đổi email",
  bank: "Thay đổi tài khoản ngân hàng",
  birthday: "Thay đổi ngày sinh",
  forget_password: "Cấp lại mật khẩu đăng nhập",
  forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  confirm_account: "Xác minh tài khoản",
};

// thông tin yêu cầu vừa gửi + nội dung gửi email / SMS xác thực (tên đăng nhập + mã yêu cầu)
function DataConfirm({ user, webSetting }) {
  const [copySuccess, setCopySuccess] = useState("");
  const requestType = REQUEST_TYPES[user.update_type] || user.update_type;
  const content = `Tên đăng nhập: ${user.account}\r\nMã yêu cầu: ${user.request_code || ""}`;
  const title = String(requestType || "").toUpperCase();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopySuccess("Đã sao chép nội dung.");
      setTimeout(() => setCopySuccess(""), 30000);
      if (user.send_type === "phone_number" && isMobile) {
        window.location.href = `sms:${webSetting?.phone_number}?body=${encodeURIComponent(content)}`;
      }
    } catch (error) {
      setCopySuccess("Không thể sao chép nội dung.");
    }
  };

  const mailLink = isMobile
    ? `mailto:${webSetting?.email}?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(content)}`
    : `https://mail.google.com/mail/?view=cm&fs=1&to=${webSetting?.email}&su=${encodeURIComponent(title)}&body=${encodeURIComponent(content)}`;

  const sendButtonClass = "inline-flex items-center justify-center min-w-[120px] sm:min-w-[140px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-[#ff9f4d] to-[#F27121] rounded-[20px] sm:rounded-[25px] shadow-[0px_2px_8px_rgba(242,113,33,0.35)] hover:shadow-[0px_4px_12px_rgba(242,113,33,0.50)] hover:scale-105 transition-all duration-200 no-underline cursor-pointer";
  const rowClass = "flex items-center justify-between gap-2 sm:gap-3 py-1.5 sm:py-2";
  const labelClass = "text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945] whitespace-nowrap";
  const valueClass = "text-[13px] sm:text-[14px] md:text-[15px] font-semibold text-[#F27121] text-right break-words";

  return (
    <div className="w-full flex flex-col gap-2.5 sm:gap-3">
      {/* 1 khung chung gồm 3 hàng: loại yêu cầu, tên đăng nhập, mã yêu cầu */}
      <div className="w-full rounded-[10px] border border-[#FEF1E9] bg-[#FFF8F3] px-3 divide-y divide-[#F3E3D7]">
        <div className={rowClass}>
          <span className={labelClass}>Yêu cầu:</span>
          <span className={valueClass}>{requestType}</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Tên đăng nhập:</span>
          <span className={valueClass}>{user.account}</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Mã yêu cầu:</span>
          <span className={`${valueClass} text-[15px] sm:text-[16px] tracking-wider`}>{user.request_code}</span>
        </div>
      </div>
      {user.update_type === "forget_password_withdraw" && (
        <p className="text-[12px] sm:text-[13px] text-[#2F3945] italic m-0">Vui lòng lưu mã yêu cầu để tra cứu kết quả khi cần.</p>
      )}
      {["email", "phone_number"].includes(user.send_type) && (
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3 mt-1">
          <div className="flex flex-col items-center gap-1.5">
            <button
              onClick={copyContent}
              className="w-full sm:w-auto min-w-[140px] sm:min-w-[160px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-[#F27121] bg-white border border-[#F27121] rounded-[20px] sm:rounded-[25px] hover:bg-[#FFF5ED] hover:scale-105 transition-all duration-200 cursor-pointer"
            >
              Sao chép nội dung
            </button>
            {copySuccess && <p className="text-[11px] sm:text-xs text-green-600 font-medium m-0">{copySuccess}</p>}
          </div>
          {user.send_type === "email" ? (
            <a href={mailLink} target="_blank" rel="noopener noreferrer" className={sendButtonClass}>Gửi Email</a>
          ) : isMobile && (
            <a href={`sms:${webSetting?.phone_number}?body=${encodeURIComponent(content)}`} className={sendButtonClass}>Gửi Tin Nhắn</a>
          )}
        </div>
      )}
    </div>
  );
}

export default DataConfirm;
